import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/_atoms/card";

export const SidebarSettingsNoTeamCard = () => {
  const { t } = useTranslation("common");

  return (
    <Card className="mt-4 text-sm">
      <CardHeader>
        <CardTitle>{"💡 "}{t("sidebar.noTeamCard.title")}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col flex-wrap gap-4 text-xs">
        <p>{t("sidebar.noTeamCard.notPartOfTeam")}</p>
        <p>{t("sidebar.noTeamCard.canAskOrCreate")}</p>
      </CardContent>
    </Card>
  );
};
